import { FC, useContext, useEffect, useMemo, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { Select, Table } from 'antd';
import DownSvg from 'assets/svg/Down';
import ErrorBox from 'components/molecules/ErrorBox/ErrorBox';
import InfiniteScroller from 'components/molecules/InfiniteScroller';
import CopyToClipBoard from 'components/molecules/MicroIntractions/CopyTOClipBoard';
import DownloadExcel from 'components/molecules/MicroIntractions/DownloadExcel';
import { nullAttrTypeOption } from 'components/pages/GrowthAnalysis';
import { commonHeaderClass } from 'components/pages/PromoScorecard';
import { colorConstants } from 'config/colorConstants';
import { UserContext } from 'contexts/ConfigContext';
import { FilterContextData } from 'contexts/FilterContext';
import { useApplyFilterMutation } from 'hooks/general/useApplyFilterMutation';
import { useFetchScoreCardExpandedGraph } from 'hooks/promoScoreCard/useFetchScoreCardExpandedGraph';
import { useFetchScoreCardExpandedTable } from 'hooks/promoScoreCard/useFetchScoreCardExpenad';

import _ from 'lodash';
import { promoScoreCardDrillDownTableParser } from 'parser/graphToExcelDownloadParser';
import tw from 'twin.macro';
import { getScoreCardBrandColumns } from 'utils/getScorecardColumns';
import { calculateContainerHeight, getConfig } from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import {
    PROMO_SCORECARD_DRILLDOWN_PRODUCT_DETAILS_DROPDOWN_CLICKED,
    PROMO_SCORECARD_TABLE_COPY,
    PROMO_SCORECARD_TABLE_EXPORT,
} from 'utils/mixpanelEventNames';

interface Props {
    questionObj: any;
    indexOfClicked: any;
    attributeTypeList: any[];
    selectedAttributeType: any;
    setSelectedAttributeType: Function;
    showGradientTile: boolean;
}
const height = 200;
const CustomTable = styled(Table)`
    .ant-table-cell-fix-left,
    .ant-table-cell-fix-right {
        background: none;
    }
    .ant-table-thead > tr > th {
        background: ${colorConstants.grey};
        padding: 0px;
        height: 44px;
    }
    .ant-table-header col:not(:last-child),
    .ant-table-body col {
        min-width: 100px;
    }
    .ant-table-thead
        > tr
        > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
            [colspan]
        ):before {
        background: none;
    }
    .ant-table-column-sorter {
        position: relative;
        left: -10px;
    }
    .ant-table-column-sorter-down,
    .ant-table-column-sorter-up {
        ${tw`!text-purpleFont`};
        opacity: 0.55;
    }
    .ant-table-column-sorter-down.active,
    .ant-table-column-sorter-up.active {
        ${tw`!text-purpleFont`};
        opacity: 1;
    }
    .ant-tooltip-open {
        ${tw`bg-darkViolet`};
    }

    border-radius: 4px;
    ${tw`border border-borderLinePurpuleAlt`}
`;
const CustomSelect = styled(Select)`
    ${tw`border border-purpleFont rounded text-[13px] text-headerColor`}
    .ant-select-selector {
        height: 100% !important;
        display: flex;
        align-items: center;
        box-shadow: none !important;
        border: none !important;
    }
    .ant-select-arrow {
        ${tw`text-headerColor`}
    }
`;
const rowKey = 'PPG';

const brandTileData = [
    { key: 1, label: 'Brand' },
    { key: 2, label: 'Promo' },
];
export const scorecardFilterOptions: any[] = [
    { label: 'Cliff', value: 1 },
    { label: 'Lune', value: 2 },
    { label: 'Quest', value: 3 },
    { label: 'zc', value: 4 },
    { label: 'asdasd', value: 5 },
    { label: 'qwewer', value: 6 },
    { label: 'hghj', value: 7 },
    { label: 'sdfsdfs', value: 8 },
];
const defaultSubFilterLimit = 5;
const subFilterLimit = 8;

const tableHeight = calculateContainerHeight(2);

const ScorecardExpandedView: FC<Props> = ({
    questionObj,
    indexOfClicked,
    attributeTypeList,
    selectedAttributeType,
    setSelectedAttributeType,
    showGradientTile,
}) => {
    const [brandTile, setBrandTile] = useState(brandTileData[0]);
    const [subFilters, setSubFilters] = useState<any[]>([]);
    const [selectedGraphItemIndex, setSelectedGraphItemIndex] = useState<null | number>(null);
    const ScorecardExpandedViewRef = useRef<any>();
    const {
        data: expandedViewGraphData,
        loading: graphDataLoading,
        fetchScoreCardExpandedGraph,
        error: graphDataError,
        setData: setExpandedViewGraphData,
    } = useFetchScoreCardExpandedGraph();
    const {
        data: applyFilterData,
        loading: applyFilterLoading,
        error: applyFilterError,
        applyFilterMutate,
    } = useApplyFilterMutation({ onComplete: onApplyFilterComplete, onError: onApplyFilterError });
    const {
        data: expandedViewTableData,
        loading: expandedTableDataLoading,
        fetchScoreCardExpandedTable,
        count,
        setLoading: setExpandedTableLoading,
        error: expandedTableDataError,
    } = useFetchScoreCardExpandedTable();
    const { timePeriodSelection, idForRestOfComponent, idForRestOfComponentFilterB } = useContext(FilterContextData);
    const { appConfig } = useContext(UserContext);
    const promoScoreCardConfig = getConfig('promoScoreCard', appConfig);
    const commonConfig = getConfig('commonConfig', appConfig);
    const { decimalForNonPercentage } = commonConfig;

    const offsetRef = useRef(commonConfig.offset || 0);
    const filterARef = useRef<any>(null);
    const selectedPromoRef = useRef<string>('');

    useEffect(() => {
        let JSONFilterA = JSON.stringify(idForRestOfComponent);
        let JSONFilterB = JSON.stringify(idForRestOfComponentFilterB);
        offsetRef.current = commonConfig.offset || 0;
        if (selectedAttributeType) {
            fetchScoreCardExpandedTable({
                variables: {
                    timePeriod: timePeriodSelection,
                    filtersA: JSONFilterA,
                    filtersB: JSONFilterB,
                    from: 'table',
                    //  contributionType: promoScoreCardConfig.promoExpandedViewTableUnit,
                    questionKey: questionObj?.QuestionIndex + 1,
                    limit: promoScoreCardConfig.limit,
                    offset: commonConfig.offset,
                    attributeType: _.snakeCase(selectedAttributeType?.label),
                },
            });
        }

        setSelectedGraphItemIndex(null);
        filterARef.current = JSONFilterA;
    }, [indexOfClicked, timePeriodSelection, selectedAttributeType, idForRestOfComponentFilterB, idForRestOfComponent]);

    const infiniteScrollOnNext = (loading: boolean) => {
        if (!loading) {
            const newOffset = offsetRef.current + promoScoreCardConfig.limit;
            const JSONFilterB = JSON.stringify(idForRestOfComponentFilterB);
            {
                fetchScoreCardExpandedTable({
                    variables: {
                        timePeriod: timePeriodSelection,
                        filtersA: filterARef.current,
                        from: 'table',
                        filtersB: JSONFilterB,
                        //  contributionType: promoScoreCardConfig.promoExpandedViewTableUnit,
                        questionKey: questionObj?.QuestionIndex + 1,
                        limit: promoScoreCardConfig.limit,
                        offset: newOffset,
                        attributeType: _.snakeCase(selectedAttributeType?.label),
                    },
                });
            }

            offsetRef.current = newOffset;
        }
    };

    const setDefaults = (scorecardFilterOptions: any[]) => {
        const temp = scorecardFilterOptions.slice(0, defaultSubFilterLimit);
        for (let i = 0; i < subFilterLimit - defaultSubFilterLimit; i++) {
            temp.push(nullAttrTypeOption);
        }
        setSubFilters(temp);
        setBrandTile(brandTileData[0]);
        setSelectedGraphItemIndex(null);
    };

    function onApplyFilterError() {
        setExpandedTableLoading(false);
    }

    //called when apply filter call has completed
    function onApplyFilterComplete(payload: any) {
        //const tempApplyFilterResponse = _.cloneDeep(JSON.parse(dummyVariables.filters));
        const tempApplyFilterResponse = _.cloneDeep(idForRestOfComponent);
        let commonIdsDim1 = [];
        let commonIdsDim2 = [];
        if (payload?.dim1?.ids?.length > 0) {
            commonIdsDim1 = [...payload.dim1.ids];
            if (idForRestOfComponent.dim1.ids?.length > 0) {
                //if no id in global filter , it means all are selected
                commonIdsDim1 = _.intersection(idForRestOfComponent.dim1.ids, payload.dim1.ids);
            }
            tempApplyFilterResponse.dim1.ids = [...commonIdsDim1];
        }
        if (payload?.dim2?.ids?.length > 0) {
            commonIdsDim2 = [...payload.dim2.ids];
            if (idForRestOfComponent.dim2.ids?.length > 0) {
                //if no id in global filter , it means all are selected
                commonIdsDim2 = _.intersection(idForRestOfComponent.dim2.ids, payload.dim2.ids);
            }
            tempApplyFilterResponse.dim2.ids = [...commonIdsDim2];
        }
        const stringifiedApplyFilterResponse = JSON.stringify(tempApplyFilterResponse);
        filterARef.current = stringifiedApplyFilterResponse;
        //fetching product
        let JSONFilterB = JSON.stringify(idForRestOfComponentFilterB);

        offsetRef.current = 0;
        fetchScoreCardExpandedTable({
            variables: {
                timePeriod: timePeriodSelection,
                filtersA: stringifiedApplyFilterResponse,
                filtersB: JSONFilterB,
                from: 'table',
                //  contributionType: promoScoreCardConfig.promoExpandedViewTableUnit,
                questionKey: questionObj?.QuestionIndex + 1,
                limit: promoScoreCardConfig.limit,
                offset: commonConfig.offset,
                attributeType: _.snakeCase(selectedAttributeType?.label),
            },
        });
    }

    useEffect(() => {
        if (!graphDataError && !graphDataLoading && expandedViewGraphData && 'brandList' in expandedViewGraphData) {
            setDefaults(expandedViewGraphData.brandList);
        }
    }, [expandedViewGraphData]);

    //table columns
    const memoisedTableParams = useMemo(() => {
        if (expandedViewTableData) {
            if (brandTile.key === 1)
                return {
                    columns: getScoreCardBrandColumns(
                        expandedViewTableData,
                        selectedAttributeType,
                        questionObj,
                        appConfig,
                        decimalForNonPercentage,
                        showGradientTile,
                        undefined,
                    ),
                    data: expandedViewTableData,
                };
            return {
                columns: getScoreCardBrandColumns(
                    expandedViewTableData,
                    selectedAttributeType,
                    questionObj,
                    appConfig,
                    decimalForNonPercentage,
                    showGradientTile,
                    selectedGraphItemIndex !== null ? selectedPromoRef.current : undefined,
                ),
                data: expandedViewTableData,
            };
        }
    }, [brandTile, selectedGraphItemIndex, selectedAttributeType, expandedViewTableData]);

    const tableExcelData = useMemo(() => {
        return promoScoreCardDrillDownTableParser(expandedViewTableData, selectedAttributeType?.label);
    }, [expandedViewTableData]);

    return (
        <div className="mt-4">
            <>
                {/* table section */}
                <div className="mt-4">
                    <div className="flex gap-3 items-center">
                        <h2 className={commonHeaderClass}>Product Details</h2>
                        <CustomSelect
                            suffixIcon={
                                <>
                                    <DownSvg />
                                </>
                            }
                            disabled={!selectedAttributeType}
                            //loading={allDimAndAttributeTypeList?.loading}
                            className="dropdown-width dropdown-height uniqSelPSDrillDownProductDetailDropdown"
                            value={selectedAttributeType?.value}
                            options={attributeTypeList}
                            onChange={(val: any, item: any) => {
                                setSelectedAttributeType(item);
                                trackEventMixpanel(PROMO_SCORECARD_DRILLDOWN_PRODUCT_DETAILS_DROPDOWN_CLICKED, {
                                    dropdownName: item?.label,
                                });
                                // trackEventMixpanel(PROMO_LANDSCAPE_DROPDOWN_CHANGE, {
                                //     'dropdown type': 'Product',
                                //     'dropdown value': item.label,
                                // });
                            }}
                        />
                    </div>

                    <div className="flex justify-between mt-4">
                        <p className="font-xs text-headerColor font-normal">
                            {questionObj['QuestionsData']}
                            <i className="font-light">{questionObj['italicsUnitsData']}</i>
                        </p>
                    </div>
                </div>
                <span className="flex gap-2 w-full justify-end mb-2">
                    <CopyToClipBoard
                        mixpanelEvent={() => trackEventMixpanel(PROMO_SCORECARD_TABLE_COPY)}
                        refOfComponent={ScorecardExpandedViewRef}
                    />
                    <DownloadExcel
                        mixpanelEvent={() => trackEventMixpanel(PROMO_SCORECARD_TABLE_EXPORT)}
                        title={'PromoScoreCard'}
                        excelData={tableExcelData?.result}
                        headers={tableExcelData?.header}
                    />
                </span>
                <div id="scorecard-table" ref={ScorecardExpandedViewRef}>
                    <InfiniteScroller
                        data={expandedViewTableData}
                        loading={expandedTableDataLoading}
                        hasMore={expandedViewTableData?.length < count || expandedTableDataLoading}
                        height={expandedViewTableData && !expandedTableDataError ? tableHeight : 'auto'}
                        onNext={() => infiniteScrollOnNext(expandedTableDataLoading)}
                    >
                        <CustomTable
                            //bordered
                            style={{
                                opacity: expandedTableDataLoading ? '0.3' : 1,
                                pointerEvents: expandedTableDataLoading ? 'none' : 'auto',
                            }}
                            pagination={false}
                            scroll={{ x: '100%' }}
                            sticky
                            rowKey={(record: any) => record[rowKey]}
                            columns={memoisedTableParams?.columns}
                            dataSource={expandedViewTableData}
                            locale={{
                                emptyText: expandedTableDataError ? (
                                    <ErrorBox msg={String(expandedTableDataError)} />
                                ) : (
                                    ''
                                ),
                            }}
                        />
                    </InfiniteScroller>
                </div>
            </>
        </div>
    );
};

export default ScorecardExpandedView;
